import React, { useState } from "react";
import { AddPromocodeAPI } from "../../../utils/APIs/promocodeApis";
import { toast } from "react-toastify";
import "./AddPromocodeModal.css";

const AddPromocodeModal = ({ isOpen, onClose, refreshData }) => {
  const [form, setForm] = useState({
    code: "",
    title: "",
    description: "",
    couponType: "Service",
    discountType: "percentage",
    discountValue: "",
    minimumAmount: "",
    maxDiscountAmount: "",
    usageLimit: "",
    validFrom: "",
    validTill: "",
    promoType: "Promocode",
    offerType: "Festive Offer",
  });

  const [loading, setLoading] = useState(false);

  const tomorrowDate = new Date();
  tomorrowDate.setDate(tomorrowDate.getDate() + 1);
  const tomorrow = tomorrowDate.toISOString().split("T")[0];

  if (!isOpen) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    // Form Validations
    if (!form.code.trim()) {
      toast.error("Promocode code is required");
      return;
    }
    if (!form.title.trim()) {
      toast.error("Title is required");
      return;
    }
    
    const discountVal = parseFloat(form.discountValue);
    if (isNaN(discountVal) || discountVal <= 0) {
      toast.error("Discount value must be a positive number");
      return;
    }
    if (form.discountType === "percentage" && discountVal > 100) {
      toast.error("Percentage discount cannot exceed 100%");
      return;
    }

    if (!form.validTill) {
      toast.error("Expiry date (Valid Till) is required");
      return;
    }

    const expiryDate = new Date(form.validTill);
    const now = new Date();
    if (expiryDate <= now) {
      toast.error("Expiry date must be in the future");
      return;
    }

    if (form.validFrom) {
      const startDate = new Date(form.validFrom);
      if (expiryDate <= startDate) {
        toast.error("Expiry date must be after the start date");
        return;
      }
    }

    if (form.minimumAmount && parseFloat(form.minimumAmount) < 0) {
      toast.error("Minimum amount cannot be negative");
      return;
    }

    if (form.usageLimit && parseInt(form.usageLimit) < 0) {
      toast.error("Usage limit cannot be negative");
      return;
    }

    try {
      setLoading(true);
      const res = await AddPromocodeAPI(form);

      if (res?.data?.success) {
        toast.success("Promocode added successfully");
        refreshData();
        onClose();
        setForm({
          code: "",
          title: "",
          description: "",
          couponType: "Service",
          discountType: "percentage",
          discountValue: "",
          minimumAmount: "",
          maxDiscountAmount: "",
          usageLimit: "",
          validFrom: "",
          validTill: "",
          promoType: "Promocode",
          offerType: "Festive Offer",
        });
      } else {
        toast.error(res?.data?.message || "Failed to add promocode");
      }
    } catch (err) {
      toast.error("Something went wrong");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box promocode-modal">
        <h3>Add Promocode</h3>

        <div className="modal-grid">
          <div className="form-group">
            <label>Promocode</label>
            <input
              name="code"
              placeholder="e.g. SERVICE50"
              value={form.code}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Title</label>
            <input
              name="title"
              placeholder="Service Discount"
              value={form.title}
              onChange={handleChange}
            />
          </div>

          <div className="form-group full-width">
            <label>Description</label>
            <textarea
              name="description"
              placeholder="50% off on services"
              value={form.description}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Type</label>
            <select name="promoType" value={form.promoType} onChange={handleChange}>
              <option value="Promocode">Promocode</option>
              <option value="Offer">Offer</option>
            </select>
          </div>





          <div className="form-group">
            <label>Discount Type</label>
            <select name="discountType" value={form.discountType} onChange={handleChange}>
              <option value="percentage">Percentage</option>
              <option value="fixed">Fixed</option>
            </select>
          </div>

          <div className="form-group">
            <label>Discount Value</label>
            <input
              name="discountValue"
              type="number"
              placeholder="50"
              value={form.discountValue}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Usage Limit</label>
            <input
              name="usageLimit"
              type="number"
              placeholder="100"
              value={form.usageLimit}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Minimum Amount</label>
            <input
              name="minimumAmount"
              type="number"
              placeholder="2000"
              value={form.minimumAmount}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Max Discount Amount</label>
            <input
              name="maxDiscountAmount"
              type="number"
              placeholder="1000"
              value={form.maxDiscountAmount}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Valid From</label>
            <input
              name="validFrom"
              type="date"
              value={form.validFrom}
              onChange={handleChange}
              min={tomorrow}
              onClick={(e) => e.target.showPicker && e.target.showPicker()}
            />
          </div>

          <div className="form-group">
            <label>Valid Till</label>
            <input
              name="validTill"
              type="date"
              value={form.validTill}
              onChange={handleChange}
              min={form.validFrom || tomorrow}
              onClick={(e) => e.target.showPicker && e.target.showPicker()}
            />
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Adding..." : "Add Promocode"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPromocodeModal;
